import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPressPiston = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 60,
	viewBox: "0 0 100.0 60.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 60.0 L 100.0 60.0 L 80.0 0.0 L 20.0 0.0 Z M 5.0 45.0 L 95.0 45.0 M 15.0 45.0 L 15.0 60.0 M 85.0 45.0 L 85.0 60.0 M 50.0 5.0 L 50.0 25.0 M 30.0 25.0 L 70.0 25.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgPressPiston;
